import React, { Component } from 'react';
import { connect } from 'react-redux';
import { popError } from '../global/actions';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

const mapStateToProps = state => ({
  errors: state.Global.errors
});

class ShowErrorToasts extends Component {
  constructor(props) {
    super(props);

    this.timeOutId = -1;

    this.onClearToast = this.onClearToast.bind(this);
    this.clearTimeout = this.clearTimeout.bind(this);
    this.setTimeout = this.setTimeout.bind(this);
  }

  componentWillUnmount() {
    this.clearTimeout();

    const { errors } = this.props;
    if (!errors || !errors.length)
      return;

    this.onClearToast(errors[0].errType);
  }

  clearTimeout = () => {
    if (this.timeOutId !== -1)
      clearTimeout(this.timeOutId);

    this.timeOutId = -1;
  }

  setTimeout = () => {
    const { errors } = this.props;
    if (!errors || !errors.length)
      return;

    if (this.timeOutId === -1) {
      this.timeOutId = setTimeout(() => {
        if (!errors || !errors.length)
          return;
        this.onClearToast(errors[0].errType);
      }, MAGIC_NUMBER.TOAST_HIDE_DELAY)
    }
  }

  onClearToast = (toastType) => {
    let { dispatch } = this.props;

    this.clearTimeout();
    dispatch(popError(toastType))
  }

  render() {
    const { errors } = this.props;
    if (!errors || !errors.length)
      return null;

    this.setTimeout();

    return (
      <div className="alert alert-danger">
        <span>{errors[0].message}</span>
        <span className="cancel" onClick={() => { this.onClearToast(errors[0].errType) }}></span>
      </div>
    )
  }
}

export default connect(mapStateToProps)(ShowErrorToasts);
